<template>
    <section class="font-poppins ">
        <div v-if="manageRider">
            <section class=" mt-10">
                <div class="text-sm flex justify-end md:flex-col">
                    
                    <div>
                        <input v-model="searchQuery" @click="search = !search" class="border outline-none w-72 p-2 rounded-lg bg-gray-100 text-xs" type="text" name="search" id="search" placeholder="Search name, email...">
                        <i class="fa fa-search -ml-8 md:hidden"></i>
                    </div>
                </div>
            </section>

            <section>
                <div>
                    <div class="flex text-sm pl-2 md:mt-2">
                        <router-link to="/pending-dso" class="text-blue-600 border p-2">Pending Dsos</router-link>
                        <router-link to="/approved-dsos" class="text-blue-600 border ml-4 p-2">Approved Dsos</router-link>
                    </div>

                    <div class=" font-bold mt-4 flex">
                        <p>Dsos List </p>
                        <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                    </div>
                </div>
            </section>

            <div class="text-sm md:overflow-x-auto">
                <table class="w-full mt-5">
                    <tbody>
                        <tr class="text-left  border-b-2">
                            <th>Dso Name</th>
                            <th>Email</th>
                            <th>Gender</th>
                            <th>Location</th>
                            <th>Carrier Mode</th>
                            <th>Status</th>
                            <th>Date Registered</th>
                        </tr>
                        
                        <tr v-for="dso in filterName" :key="dso.id" class="hover:bg-gray-300 hover:border  hover:border-blue-700 p-2 border-b-2">
                            <td>{{dso.firstName}} {{dso.lastName}}</td>
                            <td class="text-blue-700 p-1">{{dso.email}}</td>
                            <td class="w-20">{{dso.gender}}</td>
                            <td class="w-40">{{dso.country}}, {{dso.state}}</td>
                            <td>{{dso.carrierMode}}</td>
                            <td>
                                <span v-if="dso.status === 'blocked'" class="blocked"><i class="fa fa-circle mr-2"></i>{{dso.status}}</span> 
                                <span v-if="dso.status === 'approved'" class="approved"><i class="fa fa-circle mr-2"></i>{{dso.status}}</span> 
                                <span v-if="dso.status === 'deleted'" class="deleted"><i class="fa fa-circle mr-2"></i>{{dso.status}}</span> 
                                <span v-if="dso.status === 'pending'" class="pending"><i class="fa fa-circle mr-2"></i>{{dso.status}}</span> 
                            </td>
                            <td>{{moment(dso.dateRegistered).format('DD/MM/YYYY')}} <span @click="toggleList(dso)" class=" fa fa-ellipsis-v ml-3 text-gray-500 cursor-pointer"></span>
                            <div class=" relative">
                                <ul class="absolute right-5 text-xs bg-gray-50 pt-4 pb-4 pl-2 pr-2" v-show="dso.navList">
                                    <router-link :to="{name: 'pending-dso-info', params: {id: dso.email}}">
                                        <li class="border-b-2 cursor-pointer">View Information</li>
                                    </router-link> 
                                    <router-link :to="{name: 'email-center', params: {id:dso.email}}"><li class="mt-2 border-b-2  cursor-pointer">Message</li></router-link>
                                    <li  v-if=" dso.status === 'approved' || dso.status === 'active' || dso.status === 'unavailable' " class="mt-2 border-b-2  cursor-pointer" @click="blockDso(dso)">Block Dso</li>
                                    <li v-show="dso.status ==='blocked'" class="mt-2 border-b-2  cursor-pointer" @click="unblockDso(dso)">Unblock Dso</li>
                                    <li class="mt-2 border-b-2 cursor-pointer" @click="deleteDsoModal(dso)">Delete Dso</li>
                                </ul>
                            </div></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="!searchQuery" class="flex justify-between mt-10 text-gray-500 md:flex-col">
                <div>
                    <p>Showing {{currentPage}} of {{totalPages}} Pages of {{totalList}} Dsos </p>
                </div>

                <div class="flex">
                    <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                    <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
                </div>
            </div>
        </div>

        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getDsos="getDsos"
            :dsoId="dsoId"
            />
        </div>

    </section>
</template>


<script>
import axios from 'axios';
import moment from 'moment';
import {baseUrl} from '../../../Config';
const url = baseUrl;
import DeleteModal from './DeleteModal.vue';
export default {
    components: {DeleteModal},
    data() {
        return {
            filter: '',
            navList: null,
            riderInfo: false,
            manageRider: true,
            pendingRiders: false,
            dsos : [],
            page : 1,
            blockStatus : "blocked",
            unblockStatus : "approved",
            delete: "deleted",
            search: null,
            selectedName: null,
            showFilter: true,
            searchQuery : '',
            isLoading : false,
            currentList: "",
            totalList: "",
            deleteModal: false,
            message: "",
            dsoId: "",
             currentPage:1,
            pageSize:20,
            searchLength: "",
            totalPages: "",
        }
    },

    computed: {
        filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.dsos.filter((theOrder) => {  
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.dsos.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.dsos.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                if(this.totalPages == 0) {
                    this.totalPages = 1
                }
                if(index >= start && index < end) return true;
                })
            }
        }
    },

    mounted() {
        this.getDsos();
        this.networkError();
    },

    methods: {
        moment(date) {
            return moment(date);
        },
        toggleList(dso) {
            dso.navList = !dso.navList
        },

        closeModal() {
            this.deleteModal = false;
        },
        deleteDsoModal(dso) {
            this.dsoId = dso.dsoId
            dso.navList = !dso.navList
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        showDetails(eachUser) {
            this.selectedName = eachUser;
            this.showFilter = false
            this.getDsos()
        },

       next() {
            if((this.currentPage*this.pageSize) < this.dsos.length) this.currentPage++;
        },

        prev() {
            if(this.currentPage > 1) this.currentPage--
        },


        showRiderInfo() {
            this.riderInfo = true;
            this.manageRider = false
        },

        showPendingRiders() {
            this.pendingRiders = true
            this.manageRider = false
        },

        getDsos() {
            this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/dsos`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.dsos = response.data.data.results;
                this.currentList = this.dsos.length;
                this.totalList = response.data.data.meta.totalResults;
                this.isLoading = false;
            })
            .catch((error) => {
                console.log(error)
            })
            
        },

        blockDso(dso) {
            dso.navList = !dso.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${dso.dsoId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.blockStatus
                }
            })
            .then((response) => {
                this.getDsos()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        unblockDso(dso) {
            dso.navList = !dso.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${dso.dsoId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.getDsos()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        deleteDso(dsos) {
            dsos.navList = !dsos.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsoss/update/status/${dsos.dsoId}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.delete
                }
            })
            .then((response) => {
                this.getDsos()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }

        
    }
}
</script>

<style scoped>
.pending {
    color: rgb(243, 243, 9);
}
.deleted {
    color: red;
}

.approved{color: green;}
.blocked{color:red}
</style>